import { SEO_SPACER } from '@/lib/seoSpacer.ts'
import classnames from 'classnames'
import * as React from 'react'
import { BarPattern, type BarPatternVariant } from './BarPattern.tsx'

import styles from './ValueProp.module.scss'

export type ValuePropVariant = BarPatternVariant

export type ValuePropProps = {
	text: React.ReactNode
	variant?: ValuePropVariant
	className?: string
}

export const ValueProp: React.FC<ValuePropProps> = ({
	text,
	variant = 'blue',
	className,
}) => {
	return (
		<section className={classnames(styles.valueProp, className)}>
			<div className={styles.textWrapper}>
				<p className={styles.text}>
					{text}
					{SEO_SPACER}
				</p>
			</div>
			<BarPattern variant={variant} />
		</section>
	)
}
